import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  Input,
  inject,
  DestroyRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { Subject } from "rxjs";
import { DrawerService } from "src/app/dashboard/drawer.service";
import { WorkspacesService } from "../../accountant/workspaces.service";
import { NotificationsService } from "./../../../notifications.service";
import { RealTimeService } from "./real-time.service";
import { MomentModule } from "ngx-moment";
import { InitialsDirective } from "../../../../utils/initials.directive";
import { NgIf, NgFor, NgClass } from "@angular/common";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-notifications",
  templateUrl: "./notifications.component.html",
  styleUrls: ["./notifications.component.scss"],
  imports: [NgIf, NgFor, NgClass, InitialsDirective, MomentModule],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  data: any;
  notifications = [];
  canLoadMore = true;
  isLoading = true;

  readonly destroyRef = inject(DestroyRef);

  constructor(
    private router: Router,
    private notificationsService: NotificationsService,
    private realTimeService: RealTimeService,
    private localStorage: LocalStorageService,
    private drawerService: DrawerService,
    private workspacesService: WorkspacesService,
  ) {
    console.log("RealTime subscribing");
  }

  @Output() closeNotifications = new EventEmitter();
  @Output() notificationsLoaded = new EventEmitter();

  @Input() conversationUuid = null;
  @Input() workspaceNotifications: any = false;
  @Input() hasUnreadConversations: any = false;

  @Input() notificationsToMarkAsUnread: any = [];

  close(): void {
    this.closeNotifications.emit();
  }

  getNotifications() {
    this.isLoading = true;
    this.notificationsService
      .getNotifications("0", this.conversationUuid)
      .then((res) => {
        this.handleResponse(res);
        this.notificationsLoaded.emit(this.notifications);
        this.realTimeService.notificationsLoadedSubject.next(
          this.notifications,
        );
      });
  }

  loadMore() {
    this.isLoading = true;
    this.notificationsService
      .getNotifications(
        this.notifications.length.toString(),
        this.conversationUuid,
      )
      .then((res) => {
        if (res.length === this.notifications.length) {
          this.canLoadMore = false;
        }
        this.notifications = res;
        this.isLoading = false;
      });
  }

  handleResponse(res: any) {
    this.notifications = res;
    this.isLoading = false;

    this.notificationsToMarkAsUnread.forEach((uuid) => {
      this.setNotificationStatusByUuid(uuid, false);
      console.log(this.notifications);
    });
  }

  ngOnInit(): void {
    this.data = this.localStorage.get("data");

    this.realTimeService.bellNotifications
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((notification) => notification !== null),
      )
      .subscribe(() => {
        this.getNotifications();
      });

    this.getNotifications();
  }

  ngOnDestroy(): void {
    // No need to manually unsubscribe as we're using takeUntilDestroyed
  }

  calculateRouterLink(notification: any) {
    const metadata = notification?.notification?.metadata;

    if (metadata?.job_uuid) {
      console.log("job", metadata.job_uuid);
      this.drawerService.goToJob(metadata.job_uuid);
    } else if (metadata?.tracked_item_uuid) {
      console.log("tracked_item", metadata.tracked_item_uuid);
      this.drawerService.goToTrackedItem(
        metadata.tracked_item_uuid,
        notification.company_id,
      );
    } else if (metadata?.file_etag) {
      console.log("file", metadata.file_etag);
      if (notification.company_id != null) {
        this.router
          .navigate([
            `./${
              this.data["user_type"] === 1 ? "practice" : "client"
            }/workspaces`,
            notification.company_id,
            "files",
          ])
          .then(() => {
            this.workspacesService.notificationsSelectedFileObservable.next(
              metadata.file_etag,
            );
          });
      }
    } else {
      console.log("No metadata available", metadata);
      this.router.navigate([
        `./${this.data["user_type"] === 1 ? "practice" : "client"}/workspaces`,
        notification.company_id,
      ]);
    }
  }

  setNotificationStatusByUuid(uuid, status) {
    for (let x = 0; x < this.notifications.length; x++) {
      if (this.notifications[x].notification.uuid == uuid) {
        this.notifications[x].read = status;
      }
    }
  }

  markAllNotificationsAsRead() {
    for (let x = 0; x < this.notifications.length; x++) {
      this.notifications[x].read = true;
    }
  }
}
